// EnterpriceProductComponent.js

import React, { useEffect, useState } from "react";
import "./EnterpriceProductComponent.css";
import DownloadButton from "../../Common Components/DownloadButton";
import EnquiryButton from "../../Common Components/EnquiryButton";
import EnquiryPopup from "../../Common Components/EnquiryPopup";

const EnterpriceProductComponent = ({
  images,
  about,
  title,
  enterpriseFeature,
  downloadLink,
  hyperlinks = [],
  id, share,
}) => {
  const [imgId, setImgId] = useState(1);
  const [isEnquiryPopupOpen, setIsEnquiryPopupOpen] = useState(false);

  useEffect(() => {
    const displayWidth = document.querySelector(
      ".enterprise-img-showcase img:first-child"
    ).clientWidth;
    document.querySelector(
      ".enterprise-img-showcase"
    ).style.transform = `translateX(${-(imgId - 1) * displayWidth}px)`;
  }, [imgId]);

  const handleImgClick = (id, event) => {
    event.preventDefault();
    setImgId(id);
  };

  const toggleEnquiryPopup = () => {
    setIsEnquiryPopupOpen(!isEnquiryPopupOpen);
  };

  return (
    <div className="enterprise-component-div" id={id}>
      <div className="enterprise-card-wrapper">
        <div className="enterprise-card-product" >
          <div className="enterprise-product-imgs">
            <div className="enterprise-img-display">
              <div className="enterprise-img-showcase">
                {images.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Product ${index + 1}`}
                    style={{
                      width: "100%",
                      display: index + 1 === imgId ? "block" : "none",
                    }}
                  />
                ))}
              </div>
            </div>
            {/* <div className="enterprise-img-select">
              {images.map((image, index) => (
                <div className="enterprise-img-item" key={index}>
                  <button
                    className="enterprise-borderbackground"
                    data-id={index + 1}
                    onClick={(event) => handleImgClick(index + 1, event)}
                  >
                    <img
                      src={image}
                      alt={`Product ${index + 1}`}
                      style={{ width: "100%" }}
                    />
                  </button>
                </div>
              ))}
            </div> */}
          </div>
          <div className="enterprise-product-content">
            <div className="title_section">
              <h2 className="enterprise-product-title">{title}</h2>
            </div>
            <p className="enterprise-about-info">{about}</p>
            <br></br>
            <ul className="enterprise-feature">{enterpriseFeature}</ul>
            <div className="casestudy-button-enterprise">
              {hyperlinks.map((hyperlink, index) => (
                <a
                  key={index}
                  href={hyperlink.link}
                  target="_self"
                  rel="noopener noreferrer"
                  className="hyperlink-button-enterprise"
                >
                  {hyperlink.name}
                </a>
              ))}
            </div>
            <div className="enterprise-component-button-container">
              <DownloadButton downloadLink={downloadLink} />
              <EnquiryButton onClick={toggleEnquiryPopup} />
              <div className="share-container">
                {share}
              </div>
            </div>
          </div>
        </div>
      </div>
      <EnquiryPopup 
        isOpen={isEnquiryPopupOpen} 
        onClose={toggleEnquiryPopup} 
        productTitle={title}
      />
    </div>
  );
};

export default EnterpriceProductComponent;
